import { TransitionaryGoalsProvider } from './TransitionaryGoalsProvider';
import TransitionaryGoalsSection from './TransitionaryGoalsSection';

export const TransitionaryGoalsCard: React.FC = () => (
  <TransitionaryGoalsProvider>
    <TransitionaryGoalsSection />
  </TransitionaryGoalsProvider>
);
